/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { NewsModule } from "./news/news.module";
import {
  NbAccordionModule,
  NbButtonModule,
  NbCardModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbInputModule,
  NbLayoutModule,
  NbMenuModule,
  NbRouteTabsetModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { AboutModule } from "./about/about.module";
import { ContactModule } from "./contact/contact.module";
import { ContributionModule } from "./contribution/contribution.module";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { FaqModule } from "./faq/faq.module";
import { CollectionsModule } from "./collections/collections.module";
import { WalletConnectDialogComponent } from "./wallet-connect-dialog/wallet-connect-dialog.component";
import { CollectionsDialogComponent } from "./collections-dialog/collections-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RecentTransactionComponent } from "./collections/recent-transaction/recent-transaction.component";
import { TermsModule } from "./terms/terms.module";
import { TokenReleaseModule } from "./token-release/token-release.module";
import {
  ColumnChangesService,
  DimensionsHelper,
  NgxDatatableModule,
  ScrollbarHelper,
} from "@swimlane/ngx-datatable";
import { MyTransactionsDialogComponent } from "./my-transactions-dialog/my-transactions-dialog.component";
import { UserTransactionsDialogComponent } from "./user-transactions-dialog/user-transactions-dialog.component";
import { ContributionDialogComponent } from "./contribution-dialog/contribution-dialog.component";
import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { BlogModule } from "./blog/blog.module";
import { InfoModule } from "./info/info.module";
import { AddCrowdsaleComponent } from "./add-crowdsale/add-crowdsale.component";
import { AddCrowdsaleModule } from "./add-crowdsale/add-crowdsale.module";
import { DemoApplyModule } from "./demo-apply/demo-apply.module";
import { ArticlesComponent } from "./@shared/articles/articles.component";
import { HeadersInterceptor } from "./@shared/headersInterceptor.service";

// import { WalletConnectDialogModule } from './wallet-connect-dialog/wallet-connect-dialog.module';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    WalletConnectDialogComponent,
    CollectionsDialogComponent,
    MyTransactionsDialogComponent,
    UserTransactionsDialogComponent,
    ContributionDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbCardModule,
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NewsModule,
    AboutModule,
    ContactModule,
    ContributionModule,
    AddCrowdsaleModule,
    TermsModule,
    // WalletConnectDialogModule,
    FaqModule,
    CollectionsModule,
    TokenReleaseModule,
    NbMenuModule.forRoot(),
    ThemeModule,
    NbInputModule,
    NbLayoutModule,
    NbButtonModule,
    FormsModule,
    NbRouteTabsetModule,
    ReactiveFormsModule,
    Ng2SmartTableModule,
    NbSelectModule,
    NbAccordionModule,
    NgxDatatableModule,
    BlogModule,
    InfoModule,
    DemoApplyModule,
    NbSpinnerModule,
  ],
  providers: [
    ScrollbarHelper,
    DimensionsHelper,
    ColumnChangesService,
    CurrencyPipe,
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
